import Vue from 'vue'
import Router from 'vue-router'
import NProgress from 'nprogress'
import ProjectList from '@/components/ProjectList'
import Users from '@/components/Users'
import ProjectDashboard from '@/components/ProjectDashboard'
import ProjectStatistics from '@/components/ProjectStatistics'
import ProjectSetting from '@/components/ProjectSetting'
import ProjectItem from '@/components/ProjectItem'
import ProjectColor from '@/components/ProjectColor'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'ProjectList',
      component: ProjectList
    },
    {
      path: '/users',
      name: 'Users',
      component: Users
    },
    {
      path: '/dashboard',
      name: 'ProjectDashboard',
      component: ProjectDashboard
    },
    {
      path: '/statistics',
      name: 'ProjectStatistics',
      component: ProjectStatistics
    },
    {
      path: '/items',
      name: 'ProjectItem',
      component: ProjectItem
    },
    {
      path: '/colors',
      name: 'ProjectColor',
      component: ProjectColor
    },
    {
      path: '/settings',
      name: 'ProjectSetting',
      component: ProjectSetting
    }
  ]
})

router.beforeResolve((to, from, next) => {
  // If this isn't an initial page load.
  if (to.name) {
    // Start the route progress bar.
    NProgress.start()
  }
  next()
})

router.afterEach((to, from) => {
  // Complete the animation of the route progress bar.
  NProgress.done()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js